import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAuth } from "context/AuthProvider";
import Button from "components/form-elements/Button";
import ButtonCol from "components/form-elements/ButtonCol";
import InputCol from "components/form-elements/InputCol";
import Card from "components/ui-elements/Card";
import Row from "components/ui-elements/Row";
import Col from "components/ui-elements/Col";
import useAxiosFunction from "hooks/useAxiosFunction";
import useMsgBox from "hooks/useMsgBox";
import { RuleConfirmPass, RuleMinLen, RuleRequired } from "utils/MyUtils";

export default function ChangePasswordPage() {
  const { user, replaceUser } = useAuth();
  const navigate = useNavigate();
  const [showMsg] = useMsgBox();
  const [, , loading, axiosFetch] = useAxiosFunction();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (reqdata) => {
    const result = await axiosFetch({
      method: "POST",
      url: "/auth/change-password",
      data: reqdata,
      auth: true,
    });

    if (result?.data?.success) {
      replaceUser({
        ...user,
        must_change_password: false,
      });
      reset();
      await showMsg("Sukses", result?.message || "Password berhasil diubah");
      navigate("/", { replace: true });
      return;
    }

    if (result?.message) {
      showMsg("Informasi", result.message);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Card title="Ubah Password">
        <Row>
          <InputCol
            colsize="4"
            type="password"
            name="old_password"
            error={errors.old_password?.message}
            register={register}
            validation={RuleRequired}
            label="Password Saat Ini"
          />
          <InputCol
            colsize="4"
            type="password"
            name="new_password"
            error={errors.new_password?.message}
            register={register}
            validation={RuleMinLen(8)}
            label="Password Baru"
          />
          <InputCol
            colsize="4"
            type="password"
            name="confirm_password"
            error={errors.confirm_password?.message}
            register={register}
            validation={{ required: "Wajib diisi", validate: RuleConfirmPass("new_password") }}
            label="Konfirmasi Password Baru"
          />
        </Row>
      </Card>
      <Card>
        <Row>
          <ButtonCol loading={loading} type="submit" title="Simpan" block />
          {!user?.must_change_password ? (
            <Col size="2">
              <Link to="/">
                <Button title="Batal" block />
              </Link>
            </Col>
          ) : null}
        </Row>
      </Card>
    </form>
  );
}
